import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { SignupEmbedder } from 'signup-embedder';
import { ErrorKey } from '../app-active-error/ErrorKey';
import StandardError from '../app-active-error/StandardError';
import imageUrls from '../images/imageUrls';
import { RecaptchaCheckbox } from './RecaptchaCheckbox';
import { useRecaptchaChallenge } from './hooks/useRecaptchaChallenge';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { LayoutType } from 'signup-components/types';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecaptchaCreationErrorView = () => {
  const errorKey = ErrorKey.RecaptchaCreationError;
  const {
    isChallengeResolved,
    onErrorHandler,
    onExpiredHandler,
    onClick,
    onResolvedHandler
  } = useRecaptchaChallenge();
  const isEmbedded = SignupEmbedder.isActive();
  const {
    layoutType
  } = useLayoutTemplate();
  const recaptchaPosition = isEmbedded || layoutType === LayoutType.SidePanel ? 'left' : 'center';
  const sidePanelFooterButton = /*#__PURE__*/_jsx(LoadingButton, {
    "data-selenium": "retrySignup",
    disabled: !isChallengeResolved,
    use: "primary",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `error.${errorKey}.retryButtonText`
    })
  });
  const renderContent = () => {
    if (layoutType === LayoutType.SidePanel) {
      return /*#__PURE__*/_jsx(View, {
        flexGrow: 1,
        minBlockSize: "0",
        children: /*#__PURE__*/_jsx(RecaptchaCheckbox, {
          isEmbedded: isEmbedded,
          recaptchaPosition: recaptchaPosition,
          onError: onErrorHandler,
          onExpired: onExpiredHandler,
          onResolved: onResolvedHandler
        })
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(RecaptchaCheckbox, {
        isEmbedded: isEmbedded,
        recaptchaPosition: recaptchaPosition,
        onError: onErrorHandler,
        onExpired: onExpiredHandler,
        onResolved: onResolvedHandler
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(LoadingButton, {
          "data-selenium": "retrySignup",
          disabled: !isChallengeResolved,
          use: "primary",
          onClick: onClick,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `error.${errorKey}.retryButtonText`
          })
        })
      })]
    });
  };
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    imageURL: imageUrls.recaptchaVerification,
    renderContent: renderContent,
    sidePanelFooterButton: layoutType === LayoutType.SidePanel ? sidePanelFooterButton : null
  });
};
export default RecaptchaCreationErrorView;